'use client';

import { useEffect } from 'react';
import { withAsyncBoundary } from '@toss/async-boundary';
import { useAuth } from '@zep/auth';
import { useBody, useFunnel } from '@zep/react';
import { Colors } from '@zep/ui-tokens';
import { useChargeZemItems } from '../../../../services';
import { PaymentSelectStep } from './components/PaymentSelectStep';
import { ZemSelectStep } from './components/ZemSelectStep';
import { ChargeZemProvider, useChargeZem } from './ZemChargeContext';
const ZemChargeMain = () => {
  const {
    step
  } = useChargeZem();
  const [Funnel, setFunnel] = useFunnel<['ZEM_선택', '결제화면']>(['ZEM_선택', '결제화면']);
  useBody({
    attributes: [{
      name: 'style',
      value: `background-color: ${Colors.Gray50}`
    }]
  });
  useEffect(() => {
    setFunnel(step === 'payment' ? '결제화면' : 'ZEM_선택');
  }, [step, setFunnel]);
  return <Funnel data-sentry-element="Funnel" data-sentry-component="ZemChargeMain" data-sentry-source-file="ChargeZem.tsx">
      <Funnel.Step name={'ZEM_선택'} data-sentry-element="unknown" data-sentry-source-file="ChargeZem.tsx">
        <ZemSelectStep data-sentry-element="ZemSelectStep" data-sentry-source-file="ChargeZem.tsx" />
      </Funnel.Step>
      <Funnel.Step name={'결제화면'} data-sentry-element="unknown" data-sentry-source-file="ChargeZem.tsx">
        <PaymentSelectStep data-sentry-element="PaymentSelectStep" data-sentry-source-file="ChargeZem.tsx" />
      </Funnel.Step>
    </Funnel>;
};
const ZemChargeInner = () => {
  const {
    data: {
      data
    }
  } = useChargeZemItems();
  const {
    user
  } = useAuth();
  return <ChargeZemProvider initZemItems={data} countyCode={user?.countryCode ?? 'US'} data-sentry-element="ChargeZemProvider" data-sentry-component="ZemChargeInner" data-sentry-source-file="ChargeZem.tsx">
      <ZemChargeMain data-sentry-element="ZemChargeMain" data-sentry-source-file="ChargeZem.tsx" />
    </ChargeZemProvider>;
};
export const ChargeZem = withAsyncBoundary(ZemChargeInner, {
  pendingFallback: null,
  rejectedFallback: () => {
    return <div></div>;
  }
});